import { render } from "./ClientComisionesConfiguracion.vue?vue&type=template&id=497a62e7&scoped=true"
import script from "./ClientComisionesConfiguracion.vue?vue&type=script&lang=js"
export * from "./ClientComisionesConfiguracion.vue?vue&type=script&lang=js"

import "./ClientComisionesConfiguracion.vue?vue&type=style&index=0&id=497a62e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497a62e7"]])

export default __exports__